import React, { createContext, useState, useContext, useCallback } from 'react';

const LanguageContext = createContext();

const STORAGE_KEY = 'astro_lang';

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    try {
      return localStorage.getItem(STORAGE_KEY) || 'en';
    } catch {
      return 'en';
    }
  });

  const switchLanguage = useCallback((newLang) => {
    setLang(newLang);
    try {
      localStorage.setItem(STORAGE_KEY, newLang);
    } catch {}
  }, []);

  const toggleLanguage = useCallback(() => {
    const newLang = lang === 'en' ? 'ta' : 'en';
    switchLanguage(newLang);
  }, [lang, switchLanguage]);

  return (
    <LanguageContext.Provider value={{ lang, switchLanguage, toggleLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export default LanguageContext;
